import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

import { useForm, useFormValidation } from "../../hooks"
import { startLogin } from "../../redux/slices/auth";

import { CheckboxInput, EmailInput, PasswordInput, PrimaryButton } from "../../components";

import styles from './Login.module.css';

export const Login = () => {

  const dispatch = useDispatch();

  const { status } = useSelector(state => state.auth);

  const { email, password, rememberme, onInputChange } = useForm({ email: '', password: '', rememberme: true });

  const { isFormValid, formValidationStatus, formFields, startFormValidation, setFormFieldValidation } = useFormValidation([{field: 'email', default: false}, {field: 'password', default: false}]);

  useEffect(() => {
    let loginEmail = localStorage.getItem('loginEmail');
    if(loginEmail !== null){
      onInputChange({ target: { name: 'email', value: loginEmail } });
      startFormValidation();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onSubmit = async ( event ) => {
    event.preventDefault();
    
    startFormValidation();
    
    if(formValidationStatus === 'checked' && isFormValid != null && isFormValid){
      if(rememberme === 'true' || rememberme === true){
        localStorage.setItem('loginEmail', email);
      }else{
        localStorage.removeItem('loginEmail');
      }
      await dispatch(startLogin(email, password));
    }

  }

  return (
    <>
      <div className="row">
        <div className="col">
          <div className={styles.formHeader}>Login - Admin</div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <form onSubmit={ onSubmit }>
            <div className="row">
              <div className="col">
                <EmailInput
                  formFieldStatus={ formFields['email'].status }
                  label="Email"
                  name="email"
                  onChange={ onInputChange }
                  placeholder="example@email.com"
                  required={ true }
                  requiredIndicator={false}
                  setFormFieldValidation={ setFormFieldValidation }
                  value={ email }
                />
              </div>
            </div>
            <div className="row">
              <div className="col">
                <PasswordInput
                  formFieldStatus={ formFields['password'].status }
                  label="Contraseña"
                  name="password"
                  onChange={ onInputChange }
                  required={true}
                  requiredIndicator={false}
                  setFormFieldValidation={ setFormFieldValidation }
                  value={ password }
                />
              </div>
            </div>
            <div className="row">
              <div className="col">
                <CheckboxInput
                  label="Recordarme"
                  name="rememberme"
                  onChange={ onInputChange }
                  required={false}
                  checked={ (rememberme === 'true' || rememberme === true) ? true : false }
                />
              </div>
            </div>
            <div className="row">
              <div className="col">
                <div className="float-end">
                  <PrimaryButton
                    disabled={status === 'checking' || formValidationStatus === 'checking'}
                    text="Iniciar Sesión"
                    type="submit"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}
